// removed by extract-text-webpack-plugin
module.exports = {"PickerItem":"PickerItem","PickerItem__Description":"PickerItem__Description","PickerItem__mbDescription":"PickerItem__mbDescription","PickerItem__photo__block":"PickerItem__photo__block","PickerItem__photo__image":"PickerItem__photo__image","PickerItem__photo__image-mb":"PickerItem__photo__image-mb","PickerItem__pcDescription":"PickerItem__pcDescription","PickerItem__photo__image-pc":"PickerItem__photo__image-pc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/picker-item/styles.css
// module id = 824
// module chunks = 0 1